import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { Observable } from 'rxjs';
import { BlogService, BlogPost } from '../../services/blog.service';
import { ContentService, SiteContentBlog } from '../../services/content.service';

@Component({
  selector: 'app-blog',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './blog.html',
  styleUrl: './blog.scss'
})
export class Blog implements OnInit {
  blogPosts$!: Observable<BlogPost[]>;
  blogContent$!: Observable<SiteContentBlog | any>;

  constructor(private blogService: BlogService, private contentService: ContentService) {}

  ngOnInit() {
    this.blogPosts$ = this.blogService.getPosts();
    this.blogContent$ = this.contentService.getBlogContent();
  }

  getImgSrc(url: string | undefined): string {
    if (!url) return 'https://images.unsplash.com/photo-1509440159596-0249088772ff?q=80&w=2072&auto=format&fit=crop';
    return url.startsWith('/uploads/') ? `https://dev.thehuskbakery.com/api${url}` : url;
  }
}
